import type {
  LinkedModifierRow,
  ModifierListRow,
} from "@/modules/catalog/domain/types";
import { Button } from "@/components/ui/button";
import { Modal } from "@/shared/ui/Modal";


type LinkModifierSetModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  allModifiers: ModifierListRow[];
  linkedModifiers: LinkedModifierRow[];
  onSelect: (modifierId: string) => Promise<void>;
  submitting: boolean;
};

export function LinkModifierSetModal({
  open,
  onOpenChange,
  allModifiers,
  linkedModifiers,
  onSelect,
  submitting,
}: LinkModifierSetModalProps) {
  const linkedIds = new Set(linkedModifiers.map((m) => m.modifierId));
  const available = allModifiers.filter((m) => !linkedIds.has(m.id));

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="ເລືອກຊຸດຕົວເລືອກ"
      description="ເລືອກຊຸດຕົວເລືອກເພີ່ມເຂົ້າສິນຄ້າ"
      size="sm"
    >
      <div className="flex max-h-[60vh] flex-col gap-2 overflow-y-auto">
        {available.length === 0 ? (
          <p className="text-muted-foreground text-sm">
            ບໍ່ມີຊຸດຕົວເລືອກໃດເຫຼືອໃຫ້ເລືອກ ຫຼື ຜູກທຸກຊຸດແລ້ວ
          </p>
        ) : (
          available.map((m) => (
            <Button
              key={m.id}
              type="button"
              variant="outline"
              className="justify-start"
              onClick={async () => {
                await onSelect(m.id);
                onOpenChange(false);
              }}
              disabled={submitting}
            >
              {m.name} ({m.optionCount} ຕົວເລືອກ)
            </Button>
          ))
        )}
      </div>
    </Modal>
  );
}
